import React from 'react';
import { graphql } from 'gatsby';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';
import Seo from '@components/SEO/SEO';
import SliceZone from '@components/NewSliceZone/NewSliceZone';
import Layout from '@components/Layout/Layout';
import TerminalCTA from '@components/TerminalCTA/TerminalCTA';

import pageDataToSEOProps from '@prismic/utils/pageDataToSEOProps';
import StructuredData from '@prismic/utils/StructuredData';

const Homepage = ({ data }) => {
  const doc = data.prismicHomepage?.data;

  return (
    <Layout>
      <StructuredData schemaJson={doc.schema_json} />
      <Seo {...pageDataToSEOProps(doc, '/')} />
      <SliceZone slices={doc.body} />
      <TerminalCTA />
    </Layout>
  );
};

export const query = graphql`
  query HomepageQuery {
    prismicHomepage {
      _previewable
      data {
        schema_json {
          structured_data {
            text
          }
        }
        seo_canonical_url
        seo_description
        seo_og_description
        seo_og_image {
          alt
          url
        }
        seo_og_title
        seo_title
        body {
          ... on PrismicSlice {
            id
            slice_label
            slice_type
          }
          ...HomepageDataBodyHomeHero
          ...HomepageDataBodyMarketplaceTypeSelector
          ...HomepageDataBodyFeatureRow
          ...HomepageDataBodyCustomerStoriesCarousel
          ...HomepageDataBodyStats
          ...HomepageDataBodyCalloutSection
          ...HomepageDataBodyFaqSection
          ...HomepageDataBodyLatestContent
        }
      }
    }
  }
`;

export default withPrismicPreview(Homepage);
